
import BinValueConverterBase from "./BinValueConverterBase.js";

class BinToCountConverter extends BinValueConverterBase {
    _getBinValue(bin, customData) {
        return bin.data.length;
    }
}

export default BinToCountConverter;